module.exports = __webpack_public_path__ + "img/BNI.0ab4c378.png";